module.exports = __webpack_public_path__ + "img/incremental-revenue-empty-state-pulse.f4451610.svg";